export type ImportMessageDetails = {
  totalRows: number
  newRows: number
  updatedRows: number
  unchangedRows: number
  errorRows: number
  filename: string
}

export type TypeaheadOption = {
  label: string
  value: string
}

export enum ImportHistoryQueryParams {
  FILE_TYPE = 'fileType',
  STATUS = 'status',
  TAG = 'tag',
  DATE_MODE = 'dateMode',
  START_DATE = 'startDate',
  START_TIME = 'startTime',
}

export enum DateFilterMode {
  RECENT = 'recent',
  STARTING_FROM = 'startingFrom',
}
